import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fs-3"
}
const _hoisted_2 = {
  key: 1,
  class: "fs-3"
}
const _hoisted_3 = { class: "container pt-3" }
const _hoisted_4 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_5 = ["data-bs-target", "id", "onClick", "aria-controls", "aria-selected"]
const _hoisted_6 = {
  key: 0,
  class: "text-danger ms-1",
  "aria-label": "This tab has validation errors"
}
const _hoisted_7 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_8 = { class: "container-fluid py-4" }
const _hoisted_9 = { class: "row mb-3" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = {
  for: "county",
  class: "form-label"
}
const _hoisted_16 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = {
  key: 0,
  class: "form-check"
}
const _hoisted_29 = ["checked"]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = {
  class: "visiblity-hidden",
  for: "note"
}
const _hoisted_33 = { class: "py-4" }
const _hoisted_34 = { class: "table table-striped" }
const _hoisted_35 = { scope: "row" }
const _hoisted_36 = ["checked", "aria-label"]
const _hoisted_37 = { class: "mt-4" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-4 mb-2" }
const _hoisted_40 = { class: "col-md-4 mb-2" }
const _hoisted_41 = { class: "col-md-4 mb-2" }
const _hoisted_42 = { class: "col-md-4 mb-2" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-4 mb-2" }
const _hoisted_45 = { class: "col-md-4 mb-2" }
const _hoisted_46 = { class: "col-md-4 mb-2" }
const _hoisted_47 = { class: "col-md-4 mb-2" }
const _hoisted_48 = { class: "mt-4" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-4 mb-2" }
const _hoisted_51 = { class: "col-md-4 mb-2" }
const _hoisted_52 = { class: "col-md-4 mb-2" }
const _hoisted_53 = { class: "col-md-4 mb-2" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-md-4 mb-2" }
const _hoisted_56 = { class: "col-md-4 mb-2" }
const _hoisted_57 = { class: "col-md-4 mb-2" }
const _hoisted_58 = { class: "col-md-4 mb-2" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-4 mb-2" }
const _hoisted_61 = { class: "col-md-4 mb-2" }
const _hoisted_62 = { class: "col-md-4 mb-2" }
const _hoisted_63 = { class: "col-md-4 mb-2" }
const _hoisted_64 = { class: "d-flex justify-content-between mt-4 px-2" }
const _hoisted_65 = { key: 1 }

import {computed, onMounted, ref} from "vue";
import {BCard, SystemAlerts, ConfirmModal} from "./Misc";
import {BInput, BDatePicker, BTextarea, BSelect} from "./Fields";
import type {AgencyItemDetails, DataCollectionStatus} from "@/types";
import {useFormValidation} from "@/validation";
import {BButton} from "./BButton";
import {storeToRefs} from "pinia";
import {useAgencyStore} from "@/stores/agencyStore";
import {useVendorStore} from "@/stores/vendorStore";
import hasPermission from "@/composable/permissionHelper";
import {useAgencyTypeStore} from "@/stores/agencyTypesStore";
import {useCountyStore} from "@/stores/countyStore";
import {array, mixed, object, string} from "yup";

export default /*@__PURE__*/_defineComponent({
  __name: 'AgencyDetails',
  props: {
    id: String,
},
  setup(__props) {

const agencyTypeStore = useAgencyTypeStore();
const countyStore = useCountyStore();
const vendorStore = useVendorStore();

const props = __props;

const agencyTypes = computed(() => {
    return agencyTypeStore.items?.map((x) => ({value: x.code, text: x.label}));
});
const counties = computed(() => {
    return countyStore.items?.map((x) => ({value: x.code, text: x.name}));
});

const vendors = computed(() => {
    return vendorStore.items?.map((x) => ({value: x.code, text: x.name}));
});

const ori9s = computed(() => {
    return lookups.value?.map((x) => ({value: x.ori, text: x.ori}));
});
const ori7s = computed(() => {
    return lookups.value?.map((x) => ({value: x.ori7, text: x.ori7}));
});

const contactsAgencyAdministratorText = computed(() => {
    return settings.value?.contactsAgencyAdministrator.text || "Agency Administrator";
});

const contactsUcrProgramManagerText = computed(() => {
    return settings.value?.contactsUcrProgramManager.text || "UCR Program Manager";
});

const contactsCommanderText = computed(() => {
    return settings.value?.contactsCommander.text || "Commander";
});

const notesText = computed(() => {
    return settings.value?.notes.text || "Notes";
});

const editMode = computed(() => {
    return props.id != "";
});

// Normalizes a date value to "yyyy-MM-dd" so comparisons are by calendar day, not time/time zone.
const toDateKey = (value: string | Date | null | undefined) => {
    if (!value) {
        return null;
    }
    if (value instanceof Date) {
        return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
    }
    return value.substring(0, 10);
};

// Submitting = vendor assigned and today falls within the agency start/end dates (both inclusive).
const getDataCollectionStatus = (item: DataCollectionStatus) => {
    const today = toDateKey(new Date())!;
    const startDate = toDateKey(item.agencyStartDate);
    const endDate = toDateKey(item.agencyEndDate);

    return !!item.vendorCode && startDate != null && startDate <= today && (endDate == null || endDate >= today);
};

const flags = ref({sameAs7: false, differentOri9: false});
const selectedTab = ref("ori");

const allTabs = [
    {name: "Ori", id: "ori"},
    {name: "Data Collections", id: "data_collections"},
    {name: "Addresses", id: "addresses"},
    {name: "Contacts", id: "contacts"},
];


const tabs = computed(() => {
    return allTabs.filter((tab) => {
        if (tab.id === "addresses") {
            return settings.value?.mailingAddress.visible || settings.value?.locationAddress.visible;
        }

        if (tab.id === "contacts") {
            return (
                settings.value?.contactsAgencyAdministrator.visible ||
                settings.value?.contactsUcrProgramManager.visible ||
                settings.value?.contactsCommander.visible
            );
        }

        return true;
    });
});

const fieldTabMap: Record<string, string> = {
    oriName: "ori",
    agencyTypeCode: "ori",
    countyCode: "ori",
    latitude: "ori",
    longitude: "ori",
    ori: "ori",
    ori7: "ori",
    ori7Fbi: "ori",
    ori9Fbi: "ori",
    mailStreet: "addresses",
    mailTown: "addresses",
    mailState: "addresses",
    mailZip: "addresses",
    locStreet: "addresses",
    locTown: "addresses",
    locState: "addresses",
    locZip: "addresses",
    adminName: "contacts",
    adminEmail: "contacts",
    adminPhone: "contacts",
    adminFax: "contacts",
    ucrName: "contacts",
    ucrEmail: "contacts",
    ucrPhone: "contacts",
    ucrFax: "contacts",
    commName: "contacts",
    commEmail: "contacts",
    commPhone: "contacts",
    commFax: "contacts",
};

const getFieldTab = (field: string) => (field.startsWith("dataCollectionStatus") ? "data_collections" : fieldTabMap[field]);

const tabHasError = (tabId: string) => Object.keys(errors.value ?? {}).some((field) => getFieldTab(field) === tabId);

const agencyStore = useAgencyStore();

const {loading, settings, lookups, datasets} = storeToRefs(agencyStore);

const form = ref({} as AgencyItemDetails);

const currentIndex = computed(() => tabs.value.findIndex((t) => t.id === selectedTab.value));

const changeTab = async (tabId: string) => {
    if (await handleSubmit(schema.value, form.value)) {
        selectedTab.value = tabId;
    }
};

const nextTab = async () => {
    if (currentIndex.value < tabs.value.length - 1) {
        await changeTab(tabs.value[currentIndex.value + 1].id);
    }
};

const prevTab = async () => {
    if (currentIndex.value > 0) {
        await changeTab(tabs.value[currentIndex.value - 1].id);
    }
};
const canManageNotes = computed(() => {
    return hasPermission("AgencyNotes");
});
const canViewNotes = computed(() => {
    return hasPermission("AgencyNotesView");
});


const schema = computed(() => {
    const shape: Record<string, unknown> = {
        ori: string()
            .required()
            .max(9)
            .label("9-Digit ORI")
            .test("unique-ori", "Ori ${value} already exists", async function (value) {
                if (editMode.value) {
                    return true;
                }
                var oriAlreadyExists = value != undefined ? await agencyStore.checkIfOriExists(value) : true;
                return !oriAlreadyExists;
            }),
        oriName: string().required().max(100).label("Agency Name"),
        countyCode: string().required().label("County"),
        dataCollectionStatus: array().of(
            object({
                vendorCode: string()
                    .nullable()
                    .label("Vendor")
                    .when(["agencyStartDate", "agencyEndDate"], {
                        is: (startDate: string | null, endDate: string | null) => !!startDate || !!endDate,
                        then: (schema) => schema.required(),
                    }),
                agencyEndDate: mixed<string | Date>()
                    .nullable()
                    .test("end-after-start", "End Date must be after Start Date", function (endDate) {
                        const startDate = this.parent.agencyStartDate;
                        if (!startDate || !endDate) {
                            return true;
                        }
                        return new Date(endDate) > new Date(startDate);
                    }),
            })
        ),
    };

    if (settings.value?.ori7.visible) {
        shape.ori7s = string().max(7);
    }

    if (settings.value?.mailingAddress.visible) {
        shape.mailStreet = string().max(160);
        shape.mailTown = string().max(75);
        shape.mailState = string().max(10);
        shape.mailZip = string().max(10);
    }

    if (settings.value?.locationAddress.visible) {
        shape.locStreet = string().max(160);
        shape.locTown = string().max(75);
        shape.locState = string().max(10);
        shape.locZip = string().max(10);
    }

    if (settings.value?.contactsAgencyAdministrator.visible) {
        shape.adminName = string().max(500);
        shape.adminEmail = string().email().max(500).label(`${contactsAgencyAdministratorText.value} Email`);
        shape.adminPhone = string().max(500);
        shape.adminFax = string().max(50);
    }

    if (settings.value?.contactsUcrProgramManager.visible) {
        shape.ucrName = string().max(500);
        shape.ucrEmail = string().email().max(500).label(`${contactsUcrProgramManagerText.value} Email`);
        shape.ucrPhone = string().max(500);
        shape.ucrFax = string().max(50);
    }

    if (settings.value?.contactsCommander.visible) {
        shape.commName = string().max(500);
        shape.commEmail = string().email().max(500).label(`${contactsCommanderText.value} Email`);
        shape.commPhone = string().max(500);
        shape.commFax = string().max(50);
    }

    return object<AgencyItemDetails>(shape as never);
});

const {handleSubmit, errors, resetValidation} = useFormValidation();

const updateNotes = async () => {
    await agencyStore.updateNotes(props.id!, form.value.itemNote);
};

const save = async () => {
    if (await handleSubmit(schema.value, form.value)) {
        if (props.id) {
            await agencyStore.update(props.id!, form.value!);           
        } else {
            await agencyStore.create(form.value!);           
        }
        setTimeout(() => {
            window.location.href = `Agencies.aspx`;
        }, 2000);
    }
};

onMounted(async () => {
    await agencyStore.getSettings();

    await agencyStore.listLookups();

    if (editMode.value) {
        form.value = await agencyStore.getById(props.id!);
        flags.value.sameAs7 = form.value.ori7 == form.value.ori7Fbi;
        flags.value.differentOri9 = !!form.value.ori9Fbi && form.value.ori9Fbi != form.value.ori;
    } else {
        await agencyStore.listDatasets();
        form.value = {} as AgencyItemDetails;
        form.value.agencyTypeCode = -1;
        form.value.toFbi = true;
        form.value.dataCollectionStatus = datasets.value?.map(
            (x) =>
                ({
                    label: x.label,
                    dataSetId: x.code,
                    name: x.name,
                    vendorCode: "UV",
                    agencyEnabled: false,
                } as DataCollectionStatus)
        );
    }

    vendorStore.tableOptions.itemsPerPage = 10000;
    await vendorStore.list();
    await agencyTypeStore.list();
    await countyStore.list();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (editMode.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(form.value.oriName) + " (" + _toDisplayString(props.id) + ") ", 1))
      : (_openBlock(), _createElementBlock("h1", _hoisted_2, " New Agency ")),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "nav-item",
            role: "presentation",
            key: tab.id
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", {active: tab.id == selectedTab.value}]),
              "data-bs-toggle": "tab",
              "data-bs-target": `#${tab.id}`,
              type: "button",
              role: "tab",
              id: `tab-${tab.id}`,
              onClick: _withModifiers(($event: any) => (changeTab(tab.id)), ["prevent"]),
              "aria-controls": tab.id,
              "aria-selected": tab.id == selectedTab.value
            }, [
              _createTextVNode(_toDisplayString(tab.name) + " ", 1),
              (tabHasError(tab.id))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "●"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5)
          ]))
        }), 128))
      ]),
      (_unref(settings))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", {'show active': selectedTab.value === 'ori'}]),
              id: "ori",
              role: "tabpanel",
              "aria-labelledby": "tab-ori",
              tabindex: "0"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", {
                      for: "ori9",
                      class: "form-label"
                    }, " Agency ORI ", -1)),
                    _createVNode(_unref(BInput), {
                      name: "ori9",
                      modelValue: form.value.ori,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.ori) = $event)),
                      "max-length": 9,
                      disabled: editMode.value,
                      error: _unref(errors).ori
                    }, null, 8, ["modelValue", "disabled", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", {
                      for: "agencyName",
                      class: "form-label"
                    }, "Agency Name", -1)),
                    _createVNode(_unref(BInput), {
                      name: "agencyName",
                      modelValue: form.value.oriName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.oriName) = $event)),
                      error: _unref(errors).oriName
                    }, null, 8, ["modelValue", "error"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", {
                      for: "agencyType",
                      class: "form-label"
                    }, " Agency Type ", -1)),
                    _createVNode(_unref(BSelect), {
                      name: "agencyType",
                      modelValue: form.value.agencyTypeCode,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.agencyTypeCode) = $event)),
                      items: agencyTypes.value,
                      error: _unref(errors).agencyTypeCode
                    }, null, 8, ["modelValue", "items", "error"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(settings).county.text || "County"), 1),
                    _createVNode(_unref(BSelect), {
                      name: "county",
                      modelValue: form.value.countyCode,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.countyCode) = $event)),
                      items: counties.value,
                      error: _unref(errors).countyCode
                    }, null, 8, ["modelValue", "items", "error"])
                  ])
                ]),
                (_unref(settings)?.latLong.visible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", {
                          class: "form-label",
                          for: "lat"
                        }, " Latitude ", -1)),
                        _createVNode(_unref(BInput), {
                          modelValue: form.value.latitude,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.latitude) = $event)),
                          type: "number",
                          name: "lat",
                          disabled: !_unref(settings).latLong.enabled,
                          error: _unref(errors).latitude
                        }, null, 8, ["modelValue", "disabled", "error"])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", {
                          class: "form-label",
                          for: "long"
                        }, " Longitude ", -1)),
                        _createVNode(_unref(BInput), {
                          modelValue: form.value.longitude,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.longitude) = $event)),
                          type: "number",
                          name: "long",
                          disabled: !_unref(settings).latLong.enabled,
                          error: _unref(errors).longitude
                        }, null, 8, ["modelValue", "disabled", "error"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(settings)?.ori7.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 1,
                      header: "Submitting ORI"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _cache[36] || (_cache[36] = _createElementVNode("label", {
                              class: "form-label",
                              for: "ori7"
                            }, " ORI used for Summary Submissions ", -1)),
                            _createVNode(_unref(BInput), {
                              name: "ori7",
                              modelValue: form.value.ori7,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.ori7) = $event)),
                              "max-length": 7,
                              disabled: !_unref(settings)?.ori7.enabled,
                              error: _unref(errors).ori7
                            }, null, 8, ["modelValue", "disabled", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            _cache[38] || (_cache[38] = _createElementVNode("label", {
                              class: "form-label",
                              for: "ori7Fbi"
                            }, " ORI used for FBI Summary Submissions ", -1)),
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "sync7",
                                disabled: !_unref(settings)?.ori7Fbi.enabled,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((flags.value.sameAs7) = $event))
                              }, null, 8, _hoisted_23), [
                                [_vModelCheckbox, flags.value.sameAs7]
                              ]),
                              _cache[37] || (_cache[37] = _createElementVNode("label", {
                                class: "form-check-label small",
                                for: "sync7"
                              }, "Same as 7-Digit ORI", -1))
                            ]),
                            _createVNode(_unref(BSelect), {
                              name: "ori7Fbi",
                              modelValue: form.value.ori7Fbi,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.ori7Fbi) = $event)),
                              items: ori7s.value,
                              disabled: flags.value.sameAs7,
                              error: _unref(errors).ori7Fbi
                            }, null, 8, ["modelValue", "items", "disabled", "error"])
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(settings)?.ori9Fbi.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 2,
                      header: "ORI for FBI Submission"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: "toFbi",
                                checked: form.value.toFbi,
                                disabled: ""
                              }, null, 8, _hoisted_27),
                              _cache[39] || (_cache[39] = _createElementVNode("label", {
                                class: "form-check-label small",
                                for: "toFbi"
                              }, "Data included in federal submissions", -1))
                            ]),
                            (form.value.toFbi)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "differentOri9",
                                    checked: flags.value.differentOri9,
                                    disabled: ""
                                  }, null, 8, _hoisted_29),
                                  _cache[40] || (_cache[40] = _createElementVNode("label", {
                                    class: "form-check-label small",
                                    for: "differentOri9"
                                  }, "Use different ORI for federal submissions", -1))
                                ]))
                              : _createCommentVNode("", true),
                            (form.value.toFbi && flags.value.differentOri9)
                              ? (_openBlock(), _createBlock(_unref(BSelect), {
                                  key: 1,
                                  name: "ori9Fbi",
                                  "aria-label": "Federal submission ORI",
                                  modelValue: form.value.ori9Fbi,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.ori9Fbi) = $event)),
                                  items: ori9s.value,
                                  disabled: true,
                                  error: _unref(errors).ori9Fbi
                                }, null, 8, ["modelValue", "items", "error"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(settings)?.notes.visible && canViewNotes.value && editMode.value)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 3,
                      header: notesText.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(notesText.value), 1),
                            _createVNode(_unref(BTextarea), {
                              name: "note",
                              modelValue: form.value.itemNote,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.itemNote) = $event)),
                              disabled: !canManageNotes.value || !_unref(settings)?.notes.enabled
                            }, null, 8, ["modelValue", "disabled"]),
                            (canManageNotes.value && _unref(settings)?.notes.enabled)
                              ? (_openBlock(), _createBlock(_unref(BButton), {
                                  key: 0,
                                  variant: "primary",
                                  onClick: _withModifiers(updateNotes, ["prevent"]),
                                  class: "mt-2"
                                }, {
                                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                    _createTextVNode("Save Notes", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", {'show active': selectedTab.value === 'data_collections'}]),
              id: "data_collections",
              role: "tabpanel",
              "aria-labelledby": "tab-data_collections",
              tabindex: "0"
            }, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("table", _hoisted_34, [
                  _cache[42] || (_cache[42] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "Name"),
                      _createElementVNode("th", { scope: "col" }, "Submitting"),
                      _createElementVNode("th", { scope: "col" }, "Start Date"),
                      _createElementVNode("th", { scope: "col" }, "End Date"),
                      _createElementVNode("th", { scope: "col" }, "Vendor")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.dataCollectionStatus, (dataCollection, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: dataCollection.dataSetId
                      }, [
                        _createElementVNode("th", _hoisted_35, _toDisplayString(dataCollection.label), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            disabled: true,
                            checked: getDataCollectionStatus(dataCollection),
                            "aria-label": `${dataCollection.label} submitting`
                          }, null, 8, _hoisted_36)
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_unref(BDatePicker), {
                            id: `dcStartDate-${dataCollection.dataSetId}`,
                            "aria-label": `${dataCollection.label} start date`,
                            modelValue: dataCollection.agencyStartDate,
                            "onUpdate:modelValue": ($event: any) => ((dataCollection.agencyStartDate) = $event)
                          }, null, 8, ["id", "aria-label", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_unref(BDatePicker), {
                            id: `dcEndDate-${dataCollection.dataSetId}`,
                            "aria-label": `${dataCollection.label} end date`,
                            disabled: dataCollection.startDate == null,
                            error: _unref(errors)[`dataCollectionStatus[${index}].agencyEndDate`],
                            "error-id": `dcEndDate-${dataCollection.dataSetId}-error`,
                            modelValue: dataCollection.agencyEndDate,
                            "onUpdate:modelValue": ($event: any) => ((dataCollection.agencyEndDate) = $event)
                          }, null, 8, ["id", "aria-label", "disabled", "error", "error-id", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_unref(BSelect), {
                            name: `dcVendor-${dataCollection.dataSetId}`,
                            "aria-label": `${dataCollection.label} vendor`,
                            items: vendors.value,
                            "select-text": "Select vendor",
                            error: _unref(errors)[`dataCollectionStatus[${index}].vendorCode`],
                            modelValue: dataCollection.vendorCode,
                            "onUpdate:modelValue": ($event: any) => ((dataCollection.vendorCode) = $event)
                          }, null, 8, ["name", "aria-label", "items", "error", "modelValue", "onUpdate:modelValue"])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tab-pane fade", {'show active': selectedTab.value === 'addresses'}]),
              id: "addresses",
              role: "tabpanel",
              "aria-labelledby": "tab-addresses",
              tabindex: "0"
            }, [
              _createElementVNode("div", _hoisted_37, [
                (_unref(settings)?.mailingAddress.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 0,
                      header: _unref(settings)?.mailingAddress.text || 'Mailing Address'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _cache[43] || (_cache[43] = _createElementVNode("label", {
                              class: "form-label",
                              for: "mailingAddressStreet"
                            }, "Street", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.mailStreet,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.mailStreet) = $event)),
                              name: "mailingAddressStreet",
                              error: _unref(errors).mailStreet
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _cache[44] || (_cache[44] = _createElementVNode("label", {
                              class: "form-label",
                              for: "mailingAddressCity"
                            }, "City", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.mailTown,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.mailTown) = $event)),
                              name: "mailingAddressCity",
                              error: _unref(errors).mailTown
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _cache[45] || (_cache[45] = _createElementVNode("label", {
                              class: "form-label",
                              for: "mailingAddressState"
                            }, "State", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.mailState,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.mailState) = $event)),
                              name: "mailingAddressState",
                              error: _unref(errors).mailState
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _cache[46] || (_cache[46] = _createElementVNode("label", {
                              class: "form-label",
                              for: "mailingAddressZip"
                            }, "ZIP", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.mailZip,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.mailZip) = $event)),
                              name: "mailingAddressZip",
                              error: _unref(errors).mailZip
                            }, null, 8, ["modelValue", "error"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_unref(settings)?.locationAddress.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 1,
                      header: _unref(settings)?.locationAddress.text || 'Location Address'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _cache[47] || (_cache[47] = _createElementVNode("label", {
                              class: "form-label",
                              for: "locationAddressStreet"
                            }, "Street", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.locStreet,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.locStreet) = $event)),
                              name: "locationAddressStreet",
                              error: _unref(errors).locStreet
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _cache[48] || (_cache[48] = _createElementVNode("label", {
                              class: "form-label",
                              for: "locationAddressCity"
                            }, "City", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.locTown,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.locTown) = $event)),
                              name: "locationAddressCity",
                              error: _unref(errors).locTown
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _cache[49] || (_cache[49] = _createElementVNode("label", {
                              class: "form-label",
                              for: "locationAddressState"
                            }, "State", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.locState,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.locState) = $event)),
                              name: "locationAddressState",
                              error: _unref(errors).locState
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _cache[50] || (_cache[50] = _createElementVNode("label", {
                              class: "form-label",
                              for: "locationAddressZip"
                            }, "ZIP", -1)),
                            _createVNode(_unref(BInput), {
                              modelValue: form.value.locZip,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.locZip) = $event)),
                              name: "locationAddressZip",
                              error: _unref(errors).locZip
                            }, null, 8, ["modelValue", "error"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", {
              id: "contacts",
              class: _normalizeClass(["tab-pane fade", {'show active': selectedTab.value === 'contacts'}]),
              role: "tabpanel",
              "aria-labelledby": "tab-contacts",
              tabindex: "0"
            }, [
              _createElementVNode("div", _hoisted_48, [
                (_unref(settings)?.contactsAgencyAdministrator.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 0,
                      header: contactsAgencyAdministratorText.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _cache[51] || (_cache[51] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsAgencyAdministratorName"
                            }, "Name", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsAgencyAdministratorName",
                              name: "contactsAgencyAdministratorName",
                              modelValue: form.value.adminName,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.adminName) = $event)),
                              error: _unref(errors).adminName
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _cache[52] || (_cache[52] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsAgencyAdministratorEmail"
                            }, "Email", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsAgencyAdministratorEmail",
                              name: "contactsAgencyAdministratorEmail",
                              modelValue: form.value.adminEmail,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.adminEmail) = $event)),
                              error: _unref(errors).adminEmail
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _cache[53] || (_cache[53] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsAgencyAdministratorPhone"
                            }, "Phone", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsAgencyAdministratorPhone",
                              name: "contactsAgencyAdministratorPhone",
                              modelValue: form.value.adminPhone,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.adminPhone) = $event)),
                              error: _unref(errors).adminPhone
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _cache[54] || (_cache[54] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsAgencyAdministratorFax"
                            }, "Fax", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsAgencyAdministratorFax",
                              name: "contactsAgencyAdministratorFax",
                              modelValue: form.value.adminFax,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.adminFax) = $event)),
                              error: _unref(errors).adminFax
                            }, null, 8, ["modelValue", "error"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_unref(settings)?.contactsUcrProgramManager.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 1,
                      header: contactsUcrProgramManagerText.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _cache[55] || (_cache[55] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsUcrProgramManagerName"
                            }, "Name", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsUcrProgramManagerName",
                              name: "contactsUcrProgramManagerName",
                              modelValue: form.value.ucrName,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.value.ucrName) = $event)),
                              error: _unref(errors).ucrName
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _cache[56] || (_cache[56] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsUcrProgramManagerEmail"
                            }, "Email", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsUcrProgramManagerEmail",
                              name: "contactsUcrProgramManagerEmail",
                              modelValue: form.value.ucrEmail,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((form.value.ucrEmail) = $event)),
                              error: _unref(errors).ucrEmail
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _cache[57] || (_cache[57] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsUcrProgramManagerPhone"
                            }, "Phone", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsUcrProgramManagerPhone",
                              name: "contactsUcrProgramManagerPhone",
                              modelValue: form.value.ucrPhone,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((form.value.ucrPhone) = $event)),
                              error: _unref(errors).ucrPhone
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_58, [
                            _cache[58] || (_cache[58] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsUcrProgramManagerFax"
                            }, "Fax", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsUcrProgramManagerFax",
                              name: "contactsUcrProgramManagerFax",
                              modelValue: form.value.ucrFax,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((form.value.ucrFax) = $event)),
                              error: _unref(errors).ucrFax
                            }, null, 8, ["modelValue", "error"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true),
                (_unref(settings)?.contactsCommander.visible)
                  ? (_openBlock(), _createBlock(_unref(BCard), {
                      key: 2,
                      header: contactsCommanderText.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _cache[59] || (_cache[59] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsCommanderName"
                            }, "Name", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsCommanderName",
                              name: "contactsCommanderName",
                              modelValue: form.value.commName,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((form.value.commName) = $event)),
                              error: _unref(errors).commName
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _cache[60] || (_cache[60] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsCommanderEmail"
                            }, "Email", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsCommanderEmail",
                              name: "contactsCommanderEmail",
                              modelValue: form.value.commEmail,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((form.value.commEmail) = $event)),
                              error: _unref(errors).commEmail
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _cache[61] || (_cache[61] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsCommanderPhone"
                            }, "Phone", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsCommanderPhone",
                              name: "contactsCommanderPhone",
                              modelValue: form.value.commPhone,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((form.value.commPhone) = $event)),
                              error: _unref(errors).commPhone
                            }, null, 8, ["modelValue", "error"])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _cache[62] || (_cache[62] = _createElementVNode("label", {
                              class: "form-label",
                              for: "contactsCommanderFax"
                            }, "Fax", -1)),
                            _createVNode(_unref(BInput), {
                              id: "contactsCommanderFax",
                              name: "contactsCommanderFax",
                              modelValue: form.value.commFax,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((form.value.commFax) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("div", null, [
          _createVNode(_unref(BButton), {
            variant: "secondary",
            to: "Agencies.aspx"
          }, {
            default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          (currentIndex.value !== 0)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 0,
                variant: "secondary",
                class: "me-2",
                onClick: _withModifiers(prevTab, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                  _createTextVNode(" Previous ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (currentIndex.value < tabs.value.length - 1)
            ? (_openBlock(), _createBlock(_unref(BButton), {
                key: 1,
                variant: "primary",
                onClick: _withModifiers(nextTab, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                  _createTextVNode(" Next ", -1)
                ]))]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(BButton), {
                key: 2,
                variant: "primary",
                onClick: _withModifiers(save, ["prevent"])
              }, {
                default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                  _createTextVNode(" Finish ", -1)
                ]))]),
                _: 1
              }))
        ])
      ]),
      (editMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Last Updated: " + _toDisplayString(form.value.lastUpdate), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(SystemAlerts)),
    _createVNode(_unref(ConfirmModal))
  ], 64))
}
}

})